import axios from "axios";
import { baseURL } from "../config";
import { authHeader } from "./authHeader";

async function getFacilityData(token) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration`,{headers: await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function verifyName(token, payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/verify-name`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function verifyDOB(token, payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/verify-dob`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getAppointmentDetails(token) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/appointment`,{headers: await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function updateDeviceFingerprint(token, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/fingerprint`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getAllAppointmentDetails(token, patientID) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/appointments?patient_id=${patientID}&page=1&limit=50`,{headers: await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function changeAppointmentStatus(token, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/appointment`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getS3SignUrl(payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/pre-signed-url`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getIDCardDetails(token) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/identity`,{headers: await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function updateIDDetails(token, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/identity`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getCurrentSessionData() {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/session`,{headers: await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function updateCurrentSessionData(payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/session`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function updateInsurancePreference(token, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/patient-details`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getInsurancePreference(token) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/patient-details`,{headers:await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function processOcr(token, payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/process-ocr`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function addInsuranceData(token, payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/insurance`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function updateInsuranceData(token, payload, insuranceId) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/insurance/${insuranceId}`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getInsuranceList(token) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/insurances?sort_by=created_at&sort_order=asc&page=1&limit=15`,{headers:await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function changeLanguage(token, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/patient-language`,payload,{headers:await authHeader(token)});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function listQueuedDocuments(token, page, limit) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/documents?sort_by=created_at&sort_order=asc`,{headers:await authHeader(token)})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getPDFBUffer(url) {
    let data;
    try {
        data = await axios.get(`${url}`,{responseType: 'arraybuffer'})
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function getSignedURLForDocuments(documenID, payload) {
    try {
        const data = await axios.post(`${baseURL}/patient-pre-registration/patient-document/${documenID}`,payload, {headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function acknowledgeDocument(documenID, payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/patient-document/${documenID}`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function listSignatureDocuments() {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/signature-documents`,{headers:await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data:data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function GetAllComponents(documentID, page, version) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/document-components/${documentID}/${version}/${page}`,{headers:await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function GetPatientComponents(documentID, version, nextToken) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/mobile-components/${documentID}/${version}?limit=10${nextToken ? `&next_token=${nextToken}` : ''}`,{headers:await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function UpdatePatientSignature(payload) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/signature`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function UpdateDocumentComponent(payload, documenID, version, componentID) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/component/${documenID}/${version}/${encodeURIComponent(componentID)}`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function GetTemplateComponents(templateID, templateVersionID, componentID, componentType, documentID, documentVersionID) {
    let data;
    try {
        data = await axios.get(`${baseURL}/patient-pre-registration/template-components?template_id=${templateID}&template_version_id=${templateVersionID}&component_id=${componentID}&component_type=${componentType}&document_id=${documentID}&version_id=${documentVersionID}`,
            {headers:await authHeader(sessionStorage.getItem('session'))})
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, data: error.response};
    }
}

async function UpdateDocumentComponentInBatch(payload, documenID, version) {
    try {
        const data = await axios.patch(`${baseURL}/patient-pre-registration/components/${documenID}/${version}`,payload,{headers:await authHeader(sessionStorage.getItem('session'))});
        return {error: false, data: data.data};
    } catch (error) {
        return { error: true, data: error.response};
    }
}

export const dataService = {
    getFacilityData,
    verifyName,
    verifyDOB,
    getAppointmentDetails,
    updateDeviceFingerprint,
    getAllAppointmentDetails,
    changeAppointmentStatus,
    getS3SignUrl,
    getIDCardDetails,
    updateIDDetails,
    getCurrentSessionData,
    updateCurrentSessionData,
    updateInsurancePreference,
    getInsurancePreference,
    processOcr,
    addInsuranceData,
    updateInsuranceData,
    getInsuranceList,
    changeLanguage,
    listQueuedDocuments,
    getPDFBUffer,
    getSignedURLForDocuments,
    acknowledgeDocument,
    listSignatureDocuments,
    GetAllComponents,
    GetPatientComponents,
    UpdatePatientSignature,
    UpdateDocumentComponent,
    GetTemplateComponents,
    UpdateDocumentComponentInBatch
}